import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Backdrop from '@mui/material/Backdrop';
import MenuItem from '@mui/material/MenuItem';

function RelatedTaskEdit({ isPopupOpened2, updatingTaskData, isSaveButtonClicked2, handleInputChange5, setIsPopupOpened2, setIsSaveButtonClicked2, submitTaskData}) {
  return (
    <Backdrop
    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={isPopupOpened2}
    onClick={() => {
      return;
    }}
  >
  <Box
  sx={{
    display: 'flex',
    position: 'absolute',
    top: "10px",
    zIndex: 2,
    flexWrap: 'wrap',
    '& > :not(style)': {
      m: 1,
      width: '800px'
    }
  }}
   >
  <Paper elevation={1} >
  <Typography variant="h6" component="h1" gutterBottom style={{ fontWeight: 'bold', marginTop: "10px" }}>
    Task
  </Typography>
  <Divider variant="hr" style={{ borderBottom: "2px solid gray" }} />
  <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
  <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} style={{ height: "350px", overflowY: "auto" }}>
  <Grid item xs={12} md={6}>
  <InputLabel htmlFor="subject" style={{ textAlign: "left", marginBottom: "1rem" }}><span style={{ color: 'red' }}>*</span> Subject</InputLabel>
  <TextField
    margin=""
    fullWidth
    required
    type="text"
    id="subject"
    style={{ marginTop: "0.5rem" }}
    name="Subject"
    value={(updatingTaskData.Subject == "" || updatingTaskData.Subject == null) ? "" : updatingTaskData.Subject}
    placeholder="No subject!"
    InputProps={{
      readOnly: true
    }}
  />
  </Grid>

  <Grid item xs={12} md={6}>
  <InputLabel htmlFor="dueDate" style={{ textAlign: "left", marginBottom: "1rem" }}>Due Date</InputLabel>
  <TextField
    margin=""
    fullWidth
    required
    type="date"
    id="dueDate"
    style={{ marginTop: "0.5rem" }}
    name="DueDate"
    value={(updatingTaskData.ActivityDate == null || updatingTaskData.ActivityDate == "") ? "No Due Date" : updatingTaskData.ActivityDate}
    placeholder="No due date"
    InputProps={{
      readOnly: true
    }}
  />
  </Grid>

  <Grid item xs={12} md={6}>
  <InputLabel htmlFor="status" style={{ textAlign: "left", marginBottom: "1rem" }}><span style={{ color: 'red' }}>*</span> Status</InputLabel>
    <Select
      margin="normal"
      fullWidth
      type="select"
      id="status"
      value={(updatingTaskData.Status == "--None--" || updatingTaskData.Status == undefined) ? "--None--" : updatingTaskData.Status }
      name="Status"
      placeholder="Select Status"
      error={(updatingTaskData.Status == "--None--" && isSaveButtonClicked2 == true) ? true : false}
      onChange={(e) => { handleInputChange5(e) }}
      style={{ textAlign: "left" }}
    >
      <MenuItem value={"--None--"}>--None--</MenuItem>
      <MenuItem value={"Not Started"}>Not Started</MenuItem>
      <MenuItem value={"In Progress"}>In Progress</MenuItem>
      <MenuItem value={"Completed"}>Completed</MenuItem>
      <MenuItem value={"Waiting on someone else"}>Waiting on someone else</MenuItem>
      <MenuItem value={"Deferred"}>Deferred</MenuItem>
    </Select>
    { (updatingTaskData.Status == "--None--" && isSaveButtonClicked2 == true) ? <Stack sx={{ width: '100%', marginTop: "5px" }} spacing={2}>
      <Alert severity="error">Select the status</Alert>
    </Stack> : "" }
  </Grid>

  
  <Grid item xs={12} md={6}>
  <InputLabel htmlFor="priority" style={{ textAlign: "left", marginBottom: "1rem" }}><span style={{ color: 'red' }}>*</span> Priority</InputLabel>
    <Select
      margin="normal"
      fullWidth
      type="select"
      id="priority"
      value={(updatingTaskData.Priority == "--None--" || updatingTaskData.Priority == undefined) ? "--None--" : updatingTaskData.Priority}
      name="Priority"
      error={(updatingTaskData.Priority == "--None--" && isSaveButtonClicked2 == true) ? true : false}
      placeholder="Select Priority"
      onChange={(e) => { handleInputChange5(e) }}
      style={{ textAlign: "left" }}
    >
      <MenuItem value={"--None--"}>--None--</MenuItem>
      <MenuItem value={"High"}>High</MenuItem>
      <MenuItem value={"Normal"}>Normal</MenuItem>
      <MenuItem value={"Low"}>Low</MenuItem>
    </Select>
    { (updatingTaskData.Priority == "--None--" && isSaveButtonClicked2 == true) ? <Stack sx={{ width: '100%', marginTop: "5px" }} spacing={2}>
      <Alert severity="error">Select the priority</Alert>
    </Stack> : "" }
  </Grid>

  <Grid item xs={12} md={6}>
  <InputLabel htmlFor="description" style={{ textAlign: "left" }}>Description</InputLabel>
  <TextField
    margin="normal"
    fullWidth
    id="description"
    name="Description"
    value={(updatingTaskData.Description == null || updatingTaskData.Description == "") ? "" : updatingTaskData.Description}
    placeholder="Description is empty!"
    multiline
    InputProps={{
      readOnly: true
    }}
    rows={2}
    maxRows={4}
  />
  </Grid>

  </Grid>
    <Grid container spacing={2} style={{ marginTop: "8px", justifyContent: "center" }}>
    <Grid item>
      <Button variant="outlined" onClick={ () => { setIsPopupOpened2(false) }}>Cancel</Button>
    </Grid>
    <Grid item>
      <Button variant="contained" onClick={(updatingTaskData.Status == "--None--" || updatingTaskData.Priority == "--None--") ? () => { setIsPopupOpened2(true); setIsSaveButtonClicked2(true); } : () => { setIsPopupOpened2(false); setIsSaveButtonClicked2(false);submitTaskData(); }}>Update</Button>
    </Grid>
  </Grid>
    </Container>
  </Paper>
  </Box>
</Backdrop>
  )
}

export default RelatedTaskEdit;